import { MutationOptions, onlineManager } from '@tanstack/react-query';

import { isClientError } from './is-client-error';

const MAX_FAILURE_COUNT = 4;

export const retry: MutationOptions['retry'] = (failureCount, error) => {
  if (isClientError(error)) {
    return false;
  }

  // offlineFirst pauses paused mutations — do not spin retries while offline.
  if (!onlineManager.isOnline()) {
    return false;
  }

  return failureCount < MAX_FAILURE_COUNT - 1;
};
